import { ReferAndEarnLazy } from "../../lazy";
import { FreelancerDashboardLayout } from "../layout";

export const EarnPage = () => {
  return (
    <FreelancerDashboardLayout pageTitle="Earn">
      <ReferAndEarnLazy />
    </FreelancerDashboardLayout>
  );
};
